import { Component, Input } from '@angular/core';

@Component({
    selector: 'cz-document-viewer-popup',
    templateUrl: './document-viewer-popup.component.html',
    styleUrls: ['document-viewer-popup.component.css'],
    standalone: false
})
export class DocumentViewerPopupComponent {

    popupVisible: boolean = false;

    @Input() fileName: string;
    @Input() smallBtn: boolean = true;


    get isToShow(): boolean {

        if (this.ext) {
            if (this.ext === '.pdf' ||
                this.ext === '.docx' ||
                this.ext === '.msg' ||
                this.ext === '.jpg' ||
                this.ext === '.jpeg'
            ) {
                return true;
            }
        }

        return false;
    }

    get ext(): string {
        if (this.fileName) {
            return this.getFileExtension(this.fileName);
        }

        return null;
    }

    constructor() {
        this.hidePopup = this.hidePopup.bind(this);
    }

    onHiddenPopup(event) {
        this.popupVisible = false;
    }

    hidePopup() {
        this.popupVisible = false;
    }

    onClickOpen() {
        this.popupVisible = true;
    }


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? '.' + /[^.]+$/.exec(filename)[0] : undefined;
    }

    extEqual(_ext: string) {
        return _ext.toLowerCase() === this.ext.toLowerCase();
    }
}
